import Cookies from 'js-cookie';

import * as actions from 'state/actions/app';
import ACTIONS, { GEOFENCING_COOKIES } from 'state/constants';

export const fetchGeofencingData = () => async dispatch => {
  dispatch({ type: ACTIONS.FETCH_GEOFENCING_DATA_REQUEST });

  const userSelectedShopID = Cookies.get(GEOFENCING_COOKIES.USER_SELECTED_SHOP);
  const inferredUserCountry = Cookies.get(GEOFENCING_COOKIES.INFERRED_USER_COUNTRY);

  if (inferredUserCountry) {
    dispatch({
      type: ACTIONS.FETCH_GEOFENCING_DATA_SUCCESS,
      payload: {
        inferredUserCountry,
        userSelectedShopID,
      },
    });
  } else {
    dispatch({ type: ACTIONS.FETCH_GEOFENCING_DATA_FAILURE });
  }
};

export const setGeofencingShopSelection = shopID => dispatch => {
  dispatch({ type: ACTIONS.SET_GEOFENCING_SHOP_SELECTION, payload: shopID });
  dispatch(actions.closeModal());
};

export const openGeofencingShopSelector = () => dispatch => {
  dispatch(actions.openGeofencingShopSelectorModal());
};
